import React, { useEffect } from "react";
import "../App.css";
import { useOutletContext } from "react-router-dom";

import SignUpPage from "../components/signUp/signUp";

export default function SignUp() {
  const [
    auth,
    setAuth,
    user,
    setUser,
    darkmode,
    setDarkmode,
    nav,
    setNav,
    setError,
  ]: any = useOutletContext();

  useEffect(() => {
    // setNav({ ...nav, page: "profile" });
  }, []);

  return (
    <div className="row">
      <SignUpPage auth={auth} setAuth={setAuth} user={user} setUser={setUser} />
    </div>
  );
}
